var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram-logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.119,
    y1: 0.881,
    x2: 0.83,
    y2: 0.17,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#fedb16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#fec125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#fe983d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#fe5f5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fe2181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000dc"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1258",
    "data-name": "Ellipse 1258",
    cx: 48.5,
    cy: 48.5,
    r: 48.5,
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6970",
    "data-name": "Group 6970",
    transform: "translate(21.598 21.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15562",
    "data-name": "Path 15562",
    d: "M168.362,131H147.757A16.667,16.667,0,0,0,131.1,147.657v20.605a16.667,16.667,0,0,0,16.657,16.657h20.605a16.667,16.667,0,0,0,16.657-16.657V147.657A16.667,16.667,0,0,0,168.362,131ZM179,168.284a10.668,10.668,0,0,1-10.659,10.659H147.735a10.668,10.668,0,0,1-10.659-10.659V147.678a10.668,10.668,0,0,1,10.659-10.659H168.34A10.668,10.668,0,0,1,179,147.678Z",
    transform: "translate(-131.1 -131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15563",
    "data-name": "Path 15563",
    d: "M205.887,192.1a13.787,13.787,0,1,0,13.787,13.787A13.812,13.812,0,0,0,205.887,192.1Zm0,22.159a8.372,8.372,0,1,1,8.372-8.372A8.38,8.38,0,0,1,205.887,214.259Z",
    transform: "translate(-178.939 -178.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1259",
    "data-name": "Ellipse 1259",
    cx: 2.33,
    cy: 2.33,
    r: 2.33,
    transform: "matrix(0.987, -0.16, 0.16, 0.987, 38.74, 10.468)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/instagram-logo.aa6ca44cc47268fcbe01a2bd9250c06c.svg";
export { ForwardRef as ReactComponent };